<template>
  <div>
    <loginTemplate   />
  </div>
</template>

<script>
import LoginTemplate from './LoginTemplate';

export default {
  data() {
    return {
      valid:false,
      username:"",
      pass:""
    }
  },
  components: {
    LoginTemplate
  },
  methods: {
  },
  props:{
    source:String
  }
}
</script>

<style scoped>
</style>